import Vue from 'vue'
import {
  Message
} from 'element-ui';
import axios from 'axios'
import store from './store'
import router from './router'

Vue.prototype.$message = Message;

const location = window.location.href.indexOf('192.168.0.')
const location200 = window.location.href.indexOf('gogit.52shanpai.com')
const locationP = window.location.href.indexOf('dealer.52shanpai.com')
if (location != -1) {
  console.log('本地')
  // store.state.baseUrl = 'http://192.168.0.109:8393/api.v1/';
  // axios.defaults.baseURL = 'http://192.168.0.109:8393/api.v1/';

  store.state.baseUrl = 'http://gogit.52shanpai.com:1236/api.v1/'
  axios.defaults.baseURL = 'http://gogit.52shanpai.com:1236/api.v1/'
} else if (location200 != -1) {
  console.log('200')
  store.state.baseUrl = 'http://gogit.52shanpai.com:1236/api.v1/'
  axios.defaults.baseURL = 'http://gogit.52shanpai.com:1236/api.v1/'
} else if (locationP != -1) {
  console.log('生产')
  store.state.baseUrl = 'https://dealer.52shanpai.com:9298/api.v1/'
  axios.defaults.baseURL = 'https://dealer.52shanpai.com:9298/api.v1/'
}
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// 请求拦截器
axios.interceptors.request.use(
  config => {
    // 每次发送请求之前判断vuex中是否存在token        
    // 如果存在，则统一在http请求的header都加上token，这样后台根据token判断你的登录情况
    // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断 
    const checkFreeUrlList = ['admin/login', 'admin/get_verify', 'home/package/sale-list']
    const url = config.url
    const index = checkFreeUrlList.findIndex(item => {
      return url.indexOf(item) != -1
    })
    if (index == -1) {
      const access_token = store.state.access_token;
      access_token && (config.headers.Token = access_token);
    }
    return config;
  },
  error => {
    return Promise.error(error);
  })

// 响应拦截器
axios.interceptors.response.use(
  response => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据     
    // 否则的话抛出错误
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是2开头的的情况
  // 这里可以跟你们的后台开发人员协商好统一的错误状态码    
  // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
  // 下面列举几个常见的操作，其他需求可自行扩展
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        // 404请求不存在
        case 404:
          Message.error(error.response.data.message);
          break;
        // 其他错误，直接抛出错误提示
        default:
          Message.error(error.response.data.message);
      }
      return Promise.reject(error.response);
    }
  });
export function get(path, data) {
  return axios.get(path, {
    params: data
  })
    .then((response) => {
      return response.data;
    })
}

export function post(path, data, file) {
  if (file == 'file') {
    axios.headers.post['Content-Type'] = 'multipart/form-data'
  }
  if (location != -1) {
    console.log('本地')
    if (file == '8394') {
      axios.defaults.baseURL = 'http://gogit.52shanpai.com:1221/'
    }
    if(!file){
      axios.defaults.baseURL = 'http://gogit.52shanpai.com:1236/api.v1/'
    }
  } else if (location200 != -1) {
    console.log('200')
    if (file == '8394') {
      axios.defaults.baseURL = 'http://gogit.52shanpai.com:1221/'
    }
    if(!file){
      axios.defaults.baseURL = 'http://gogit.52shanpai.com:1236/api.v1/'
    }
  } else if (locationP != -1) {
    console.log('生产')
    if (file == '8394') {
      axios.defaults.baseURL = 'https://dealer.52shanpai.com:9299/'
    }
    if(!file){
      axios.defaults.baseURL = 'https://dealer.52shanpai.com:9298/api.v1/'
    }
  }

  return axios.post(path, data)
    .then((response) => {
      var res = response.data
      if (res.code == 401 || res.code == 402) {
        // Message.error(res.message);
        store.state.access_token = '';
        store.state.activeMenu = '';
        setTimeout(() => {
          router.push({
            path: '/login'
          });
        }, 1000);
      }
      return res;
    });
}